module.exports = __webpack_public_path__ + "img/bg_figure1.bc913712.png";